import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeSystemCohort } from '../actions';
import SystemCohortPanel from '../components/SystemCohortPanel';

export default {
  ...tabTemplate('system-cohort', SystemCohortPanel, matchSingleUrl(['requests', 'cohort'])),
  ...tabCloser('closeSystemCohortTab', closeSystemCohort),
  ...tabIcons('filter'),
  access: ({ requests }) => requests.read,
  order: 410,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2], 'system'),
};
